import { useMemo, useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { BusinessHours } from './BusinessHours'
import { LoanPrograms } from './LoanProgams'
import { Rules } from './Rules'

export function SecondaryMarketing() {
  const [selectedMenu, setSelectedMenu] = useState('loanPrograms')
  const menus = {
    loanPrograms: 'Loan Programs',
    businessHours: 'Lock Desk Business Hours',
    rules: 'Rules',
  }

  const renderFragment = useMemo(() => {
    switch (selectedMenu) {
      case 'loanPrograms':
        return <LoanPrograms />

      case 'businessHours':
        return <BusinessHours />

      case 'rules':
        return <Rules />

      default: {
        return <div>Comming Soon...</div>
      }
    }
  }, [selectedMenu])

  return (
    <div className="secondary-marketing-container">
      <ButtonGroup title={menus} value={selectedMenu} onChange={setSelectedMenu} />
      <div className="">{renderFragment}</div>
    </div>
  )
}
